import React, { useRef } from "react";

function FloatInput({ value, onChange, placeholder, isSheetLength = false, min, max }) {
  // Если это поле для длины листа, устанавливаем ограничения
  const minValue = isSheetLength ? 0.8 : min;
  const maxValue = isSheetLength ? 6.4 : max;
  const inputRef = useRef(null);
  
  const handleChange = (e) => {
    let inputValue = e.target.value;

    // ❌ Ограничиваем ввод максимум 10 символами
    if (inputValue.length > 10) return;
    
    // ✅ Разрешаем пустое значение (считаем его за 0)
    if (inputValue === "") {
      onChange("");
      return;
    }
    
    // ❌ Запрещаем начинать с точки, запятой или нескольких нулей
    if (/^0[0-9]+/.test(inputValue)) return; // Запрещаем 00, 000, 01 и т.д.
    if (/^[.,]/.test(inputValue)) return; // Запрещаем начинать с точки/запятой

    // ✅ Разрешаем ввод только чисел и одной точки/запятой
    if (/^(0|[1-9][0-9]*)([.,]?[0-9]*)?$/.test(inputValue)) {
      // ✅ Заменяем запятую на точку при сохранении
      const storedValue = inputValue.replace(",", ".");
      
      // Проверяем ограничения min и max, если они заданы
      if (isSheetLength || minValue !== undefined || maxValue !== undefined) {
        const numValue = parseFloat(storedValue);
        if (!isNaN(numValue)) {
          if (minValue !== undefined && numValue < minValue) {
            onChange(minValue.toString());
            return;
          }
          if (maxValue !== undefined && numValue > maxValue) {
            onChange(maxValue.toString());
            return;
          }
        }
      }
      
      onChange(storedValue);
    }
  };

  // Обработчик при потере фокуса для проверки значений
  const handleBlur = () => {
    if (value === "") return;
    
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      if (isSheetLength || minValue !== undefined || maxValue !== undefined) {
        if (minValue !== undefined && numValue < minValue) {
          onChange(minValue.toString());
        } else if (maxValue !== undefined && numValue > maxValue) {
          onChange(maxValue.toString());
        }
      }
    }
  };

  // Обработчик для кнопок увеличения/уменьшения значения
  const handleIncrement = () => {
    if (value === "") {
      onChange(minValue ? minValue.toString() : "0.35");
      return;
    }
    
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      let newValue = Math.round((numValue + 0.35) * 100) / 100;
      if (maxValue !== undefined && newValue > maxValue) {
        newValue = maxValue;
      }
      onChange(newValue.toString());
    }
  };

  const handleDecrement = () => {
    if (value === "") {
      onChange(minValue ? minValue.toString() : "0");
      return;
    }
    
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      let newValue = Math.round((numValue - 0.35) * 100) / 100;
      if (minValue !== undefined && newValue < minValue) {
        newValue = minValue;
      }
      onChange(newValue.toString());
    }
  };

  // Обработчик нажатия клавиш для предотвращения ручного ввода в поле длины листа
  const handleKeyDown = (e) => {
    if (isSheetLength) {
      // Разрешаем только навигационные клавиши (стрелки, Tab, Backspace, Delete)
      const allowedKeys = ['Tab', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete'];
      if (!allowedKeys.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  // Определяем стили для кнопок
  const buttonStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '36px',
    fontWeight: 'bold',
    boxShadow: '0 2px 3px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease',
  };

  return (
    <div className="input-group">
      <input
        ref={inputRef}
        type="text"
        step="0.35"
        min={minValue}
        max={maxValue}
        value={value} // ✅ Показываем запятую вместо точки
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="form-control fs-6"
        placeholder={placeholder || ""}
        maxLength={10} // 🔹 Ограничение на 10 символов (для доп. защиты)
        readOnly={isSheetLength} // Делаем поле только для чтения, если это поле длины листа
        style={isSheetLength ? { textAlign: 'center', backgroundColor: '#f8f9fa' } : {}}
      />
      {isSheetLength && (
        <>
          <button 
            className="btn btn-primary"
            type="button"
            onClick={handleDecrement}
            style={buttonStyle}
            title="Уменьшить на 0.35 м"
          >
            <span>−</span>
          </button>
          <button 
            className="btn btn-primary" 
            type="button"
            onClick={handleIncrement}
            style={buttonStyle}
            title="Увеличить на 0.35 м"
          >
            <span>+</span>
          </button>
        </>
      )}
    </div>
  );
}

export default FloatInput;
